
import { createSlice } from '@reduxjs/toolkit';
import categoryService from '../../../../services/category/CategoryService';



export const categorySlice = createSlice({
    name: "category",
    initialState: {
        categories: [],
        count: 0,
        filterOptions: {
            page: 1,
            limit: 10,
        },
    },
    reducers: {
        updateCategories: (state, action) => {
            state.categories = action.payload
        },
        updateCategoryCount: (state, action) => {
            state.count = action.payload
        },
        updateFilterOptions: (state, action) => {
            state.filterOptions = action.payload
        },
    }
})

export const changeFilterOptionsAsync = ({...params}) => dispatch => {
    dispatch(categoryService.actions.updateFilterOptions({...params}))
}


export const getCategoriesAsync = ({page, limit, ...filters}) => dispatch => {
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}

    return new Promise((resolve, reject) => {
        categoryService.categories(params)
            .then((response) => {
                dispatch(categorySlice.actions.updateCategories(response.data))
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getCategoryCountAsync = (params) => dispatch => {
    let { limit, page, ...filters} = params

    return new Promise((resolve, reject) => {
        categoryService.categoriesCount(filters)
            .then((response) => {
                dispatch(categorySlice.actions.updateCategoryCount(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const categoryRegisterAsync = (payload) => {
    console.log(payload);
    return new Promise((resolve, reject) => {
        categoryService.categoryRegister(payload)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const categoryUpdateAsync = ({id, name}) => {
    return new Promise((resolve, reject) => {
        categoryService.categoryUpdate({id, name})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}



export const selectCategoryFilterOptions = state => state.category.filterOptions
export const selectCategoryCount = state => state.category.count
export const selectCategories = state => state.category.categories



export default categorySlice.reducer